import {
	AlertDialog,
	AlertDialogAction,
	AlertDialogCancel,
	AlertDialogContent,
	AlertDialogDescription,
	AlertDialogFooter,
	AlertDialogHeader,
	AlertDialogTitle,
} from "@/dentlab/src/components/ui/alert-dialog";

interface PatientRemoveOrphanDialogProps {
	open: boolean;
	onOpenChange: (open: boolean) => void;
	patientLabel: string;
	onUnlinkOnly: () => void;
	onDeleteAll: () => void;
}

export const PatientRemoveOrphanDialog: React.FC<
	PatientRemoveOrphanDialogProps
> = ({ open, onOpenChange, patientLabel, onUnlinkOnly, onDeleteAll }) => {
	return (
		<AlertDialog open={open} onOpenChange={onOpenChange}>
			<AlertDialogContent>
				<AlertDialogHeader>
					<AlertDialogTitle>
						Patient komplett löschen?
					</AlertDialogTitle>
					<AlertDialogDescription>
						{patientLabel} ist mit keinem anderen Auftrag verknüpft.
						Möchten Sie den Patienten nur vom Auftrag entfernen oder
						komplett aus der Datenbank löschen?
					</AlertDialogDescription>
				</AlertDialogHeader>
				<AlertDialogFooter>
					<AlertDialogCancel
						aria-label="Abbrechen"
						data-testid="patient-remove-cancel"
					>
						Abbrechen
					</AlertDialogCancel>
					<AlertDialogAction
						onClick={onUnlinkOnly}
						aria-label="Nur vom Auftrag entfernen"
						data-testid="patient-remove-unlink-only"
					>
						Nur vom Auftrag entfernen
					</AlertDialogAction>
					<AlertDialogAction
						onClick={onDeleteAll}
						aria-label="Patient komplett löschen"
						data-testid="patient-remove-delete-all"
						className="bg-destructive text-destructive-foreground hover:bg-destructive/90"
					>
						Patient komplett löschen
					</AlertDialogAction>
				</AlertDialogFooter>
			</AlertDialogContent>
		</AlertDialog>
	);
};
